// extracted by mini-css-extract-plugin
export var arrow = "filter-group-title-module--arrow--e9b52";
export var open = "filter-group-title-module--open--14cc5";
export var title = "filter-group-title-module--title--047b1";